var map = {
	"./afl.png": "9f51",
	"./avatar.png": "1195",
	"./ball-serve.jpg": "f33b",
	"./bg-court.svg": "1b35",
	"./buy-sell.png": "2353",
	"./chips.png": "0507",
	"./circle_one.png": "8152",
	"./circle_three.png": "0318",
	"./circle_two.png": "8ec6",
	"./damnn_group_header.png": "1281",
	"./dashboard1.png": "a7e9",
	"./dashboard2.png": "c77d",
	"./depositeback.png": "6f55",
	"./epl.jpg": "e830",
	"./example-left-hand-side_1.png": "e624",
	"./example-left-hand-side_2.png": "84c6",
	"./f1.png": "46fd",
	"./fantasy-logo.png": "9401",
	"./fb-msg.png": "55fd",
	"./fb.png": "e219",
	"./fixture.png": "5b1f",
	"./flat_icon/flaticon.css": "8b10",
	"./flat_icon/flaticon.eot": "845f",
	"./flat_icon/flaticon.scss": "033a",
	"./flat_icon/flaticon.svg": "8d1e",
	"./flat_icon/flaticon.ttf": "f080",
	"./flat_icon/flaticon.woff": "6d88",
	"./flat_icon/flaticon.woff2": "0b7c",
	"./football-vertical.png": "05c8",
	"./football.jpg": "1bbc",
	"./football.png": "f9c7",
	"./football_vertical.jpg": "c465",
	"./green1.png": "1431",
	"./green2.png": "eb78",
	"./green3.png": "a22f",
	"./green4.png": "28f3",
	"./green5.png": "9460",
	"./green6.png": "0d4d",
	"./green7.png": "9f55",
	"./green_line_graph.png": "c2a3",
	"./history.png": "5bf3",
	"./icomoon.eot": "25a6",
	"./icomoon.svg": "861a",
	"./icomoon.ttf": "9845",
	"./icomoon.woff": "ade5",
	"./ladder.png": "8ba4",
	"./line.png": "aa06",
	"./link.png": "61be",
	"./logo.png": "cf05",
	"./lose.png": "cbc4",
	"./nationality.png": "c6d7",
	"./nfl.png": "5722",
	"./no-image.png": "bd21",
	"./orange.png": "4430",
	"./position.png": "9b25",
	"./red1.png": "0e60",
	"./red2.png": "8a3c",
	"./red3.png": "0826",
	"./red4.png": "7f3f",
	"./red5.png": "6933",
	"./red6.png": "c5327",
	"./red7.png": "84f7",
	"./red_line_graph.png": "f677",
	"./referal.png": "afce",
	"./st.png": "5ffe",
	"./statss.png": "f28f",
	"./transaction-old.png": "d9a7",
	"./transaction.png": "a404",
	"./trophy.png": "95e9",
	"./twitter.png": "e4d7",
	"./unnamed.png": "1d76",
	"./whatsapp.png": "9673",
	"./win.png": "a1cc",
	"./world.png": "47de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";